import { Navigate, useLocation } from 'react-router-dom';

// project imports
import { GuardProps } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import { getUserHomePath, isAdmin, isAdminRoute } from '@/utils/role';

// ==============================|| ADMIN ROUTE GUARD ||============================== //

/**
 * Keeps users on routes allowed for their role:
 * - non-admins are redirected away from admin routes
 * - admins are redirected away from non-admin routes
 */
const AdminRouteGuard = ({ children }: GuardProps) => {
    const location = useLocation();
    const { user, permissions } = useAppSelector(({ auth }) => auth);
    const onAdminRoute = isAdminRoute(location.pathname);
    const userIsAdmin = isAdmin(user);

    if ((onAdminRoute && !userIsAdmin) || (!onAdminRoute && userIsAdmin)) {
        return <Navigate to={getUserHomePath(user, permissions)} replace />;
    }

    return children;
};

export default AdminRouteGuard;
